export default __webpack_public_path__ + "static/image3-4e9e91dd9b1c80e915ead4d8a9e27388.jpg";